(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["misty-duo"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function(){
  if (typeof window.toggleAcc === 'undefined') {
    window.toggleAcc = function(id){
      var item = document.getElementById(id);
      if (!item) return;
      var was = item.classList.contains('open');
      document.querySelectorAll('.qx-acc-item').forEach(function(el){ el.classList.remove('open'); });
      if (!was) item.classList.add('open');
    };
  }

  var els = document.querySelectorAll('#qx-duo-info .r');
  if (els.length) {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting) { e.target.classList.add('v'); io.unobserve(e.target); }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function(el){ io.observe(el); });
  }

  var f = document.getElementById('f-duo');
  var b = document.getElementById('b-duo');
  if (f && b) {
    function cartSectionIds(){
      return Array.prototype.slice.call(document.querySelectorAll('cart-items-component')).map(function(component){
        return component && component.dataset ? component.dataset.sectionId : '';
      }).filter(Boolean);
    }

    function openCartDrawer(){
      if (window.QxCartDrawer && typeof window.QxCartDrawer.open === 'function') {
        window.QxCartDrawer.open();
        return;
      }
      var drawer = document.querySelector('cart-drawer-component');
      if (drawer && typeof drawer.open === 'function') {
        drawer.open();
      }
    }

    f.addEventListener('submit', function(e){
      e.preventDefault();
      var vid = f.querySelector('input[name="id"]').value;
      if (!vid) return;
      b.classList.add('loading');
      b.innerHTML = 'Adding…';
      var payload = { items: [{ id: parseInt(vid, 10), quantity: 1 }] };
      var sections = cartSectionIds();
      if (sections.length) {
        payload.sections = sections.join(',');
        payload.sections_url = window.location.pathname;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      })
      .then(function(r){ if (!r.ok) throw new Error(); return r.json(); })
      .then(function(response){
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function(cartResponse){
            if (!cartResponse.ok) return null;
            return cartResponse.json();
          })
          .catch(function(){ return null; })
          .then(function(cart){
            b.innerHTML = 'Added to cart';
            b.classList.remove('loading');
            b.classList.add('success');

            document.dispatchEvent(new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: cart || response,
                sourceId: 'qx-duo-info',
                data: {
                  source: 'misty-duo',
                  itemCount: cart && typeof cart.item_count === 'number' ? cart.item_count : 1,
                  variantId: String(vid),
                  sections: response.sections || {}
                }
              }
            }));

            window.setTimeout(openCartDrawer, 180);
            setTimeout(function(){ b.innerHTML = 'Add to Cart'; b.classList.remove('success'); }, 2400);
          });
      })
      .catch(function(){
        b.innerHTML = 'Try again';
        b.classList.remove('loading');
        setTimeout(function(){ b.innerHTML = 'Add to Cart'; }, 2500);
      });
    }, { capture: true, passive: false });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["misty-ritual"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  window.setStep = function(idx) {
    document.querySelectorAll('.qx-rstep').forEach(function(el, i) {
      el.classList.toggle('on', i === idx);
    });
  };
  
  var els = document.querySelectorAll('.qx-ritual .r, .qx-ritual .sr, .qx-results-v3 .r');
  if (els.length) {
    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) { 
          e.target.classList.add('v'); 
          io.unobserve(e.target); 
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function(el) { io.observe(el); });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["qx-cart-dedup"] && !Shopify.designMode) return;
  try {
    
    (function(){
      var root=document.querySelector('[data-qx-cart-dedup]');
      if(!root)return;

      if(window.QxCartDedup&&window.QxCartDedup.__initialized){
        window.QxCartDedup.setRoot(root);
        return;
      }

      var listenerOptions={capture:true,passive:false};
      var activeRoot=root;
      var backdrop=root.querySelector('[data-qx-dedup-backdrop]');
      var modal=root.querySelector('[data-qx-dedup-modal]');
      var headline=root.querySelector('[data-qx-dedup-headline]');
      var body=root.querySelector('[data-qx-dedup-body]');
      var swapButton=root.querySelector('[data-qx-dedup-swap]');
      var keepButton=root.querySelector('[data-qx-dedup-keep]');
      var cancelButton=root.querySelector('[data-qx-dedup-cancel]');
      var closeButton=root.querySelector('[data-qx-dedup-close]');
      var currentResolve=null;
      var previousFocus=null;

      function setRoot(nextRoot){
        activeRoot=nextRoot||activeRoot;
        backdrop=activeRoot.querySelector('[data-qx-dedup-backdrop]');
        modal=activeRoot.querySelector('[data-qx-dedup-modal]');
        headline=activeRoot.querySelector('[data-qx-dedup-headline]');
        body=activeRoot.querySelector('[data-qx-dedup-body]');
        swapButton=activeRoot.querySelector('[data-qx-dedup-swap]');
        keepButton=activeRoot.querySelector('[data-qx-dedup-keep]');
        cancelButton=activeRoot.querySelector('[data-qx-dedup-cancel]');
        closeButton=activeRoot.querySelector('[data-qx-dedup-close]');
        bindModalButtons();
      }

      function enabled(){
        return activeRoot&&activeRoot.dataset.enabled==='true';
      }

      function text(template,replacements){
        return String(template||'').replace(/\{product\}/g,replacements.product||'this item').replace(/\{existing\}/g,replacements.existing||'your current selection').replace(/\{new\}/g,replacements.newLabel||'this selection');
      }

      function getSectionIds(){
        return Array.prototype.slice.call(document.querySelectorAll('cart-items-component')).map(function(component){
          return component&&component.dataset?component.dataset.sectionId:'';
        }).filter(Boolean);
      }

      function appendSectionsToFormData(formData){
        var sectionIds=getSectionIds();
        if(sectionIds.length&&!formData.has('sections')){
          formData.append('sections',sectionIds.join(','));
        }
        if(!formData.has('sections_url')){
          formData.append('sections_url',window.location.pathname);
        }
      }

      function withSections(payload){
        var next={};
        Object.keys(payload||{}).forEach(function(key){next[key]=payload[key];});
        var sectionIds=getSectionIds();
        if(sectionIds.length&&!next.sections){
          next.sections=sectionIds.join(',');
          next.sections_url=window.location.pathname;
        }
        return next;
      }

      function fetchCart(){
        return fetch(activeRoot.dataset.cartUrl,{headers:{'Accept':'application/json'}}).then(function(response){
          if(!response.ok)throw response;
          return response.json();
        });
      }

      function linePlanId(line){
        return line&&line.selling_plan_allocation&&line.selling_plan_allocation.selling_plan&&line.selling_plan_allocation.selling_plan.id?String(line.selling_plan_allocation.selling_plan.id):'';
      }

      function lineLabel(line){
        if(!line)return 'your current selection';
        if(line.selling_plan_allocation&&line.selling_plan_allocation.selling_plan&&line.selling_plan_allocation.selling_plan.name){
          return line.selling_plan_allocation.selling_plan.name.replace(/\s*—\s*/g,' · ');
        }
        if(line.variant_title&&line.variant_title!=='Default Title'){
          return line.variant_title;
        }
        return 'one-time purchase';
      }

      function findConflict(cart,payload,meta){
        var variantId=payload&&payload.id?String(payload.id):'';
        var productId=meta&&meta.productId?String(meta.productId):'';
        var newPlan=payload&&payload.selling_plan?String(payload.selling_plan):'';
        if(!cart||!cart.items||!variantId)return null;

        for(var i=0;i<cart.items.length;i+=1){
          var line=cart.items[i];
          var sameVariant=String(line.variant_id)===variantId;
          var sameProduct=productId&&String(line.product_id)===productId;
          if(!sameVariant&&!sameProduct)continue;

          var differentVariant=sameProduct&&String(line.variant_id)!==variantId;
          var differentPlan=linePlanId(line)!==newPlan;
          if(differentVariant||(sameVariant&&differentPlan)){
            return line;
          }
        }
        return null;
      }

      function newLabel(payload,meta){
        if(meta&&meta.newLabel)return meta.newLabel;
        if(payload&&payload.selling_plan)return 'subscription';
        return 'one-time purchase';
      }

      function openModal(conflict,payload,meta){
        return new Promise(function(resolve){
          if(!backdrop||!modal){
            resolve('keep');
            return;
          }

          var replacements={
            product:(meta&&meta.productTitle)||conflict.product_title||'this item',
            existing:lineLabel(conflict),
            newLabel:newLabel(payload,meta)
          };

          if(headline)headline.textContent=text(activeRoot.dataset.headlineTemplate,replacements);
          if(body)body.textContent=text(activeRoot.dataset.bodyTemplate,replacements);
          if(swapButton)swapButton.textContent=text(activeRoot.dataset.swapTemplate,replacements);
          if(keepButton)keepButton.textContent=activeRoot.dataset.keepLabel||'Keep both';
          if(cancelButton)cancelButton.textContent=activeRoot.dataset.cancelLabel||'Cancel';

          currentResolve=function(choice){
            closeModal();
            resolve(choice);
          };

          previousFocus=document.activeElement;
          backdrop.hidden=false;
          window.requestAnimationFrame(function(){
            backdrop.classList.add('is-open');
            if(swapButton)swapButton.focus();
            else modal.focus();
          });
        });
      }

      function closeModal(){
        if(!backdrop)return;
        backdrop.classList.remove('is-open');
        window.setTimeout(function(){
          if(backdrop)backdrop.hidden=true;
        },300);
        currentResolve=null;
        if(previousFocus&&typeof previousFocus.focus==='function'){
          previousFocus.focus();
        }
      }

      function choose(choice){
        if(currentResolve)currentResolve(choice);
      }

      function bindModalButtons(){
        if(swapButton&&!swapButton.dataset.qxBound){
          swapButton.dataset.qxBound='true';
          swapButton.addEventListener('click',function(event){event.preventDefault();choose('swap');},listenerOptions);
        }
        if(keepButton&&!keepButton.dataset.qxBound){
          keepButton.dataset.qxBound='true';
          keepButton.addEventListener('click',function(event){event.preventDefault();choose('keep');},listenerOptions);
        }
        if(cancelButton&&!cancelButton.dataset.qxBound){
          cancelButton.dataset.qxBound='true';
          cancelButton.addEventListener('click',function(event){event.preventDefault();choose('cancel');},listenerOptions);
        }
        if(closeButton&&!closeButton.dataset.qxBound){
          closeButton.dataset.qxBound='true';
          closeButton.addEventListener('click',function(event){event.preventDefault();choose('cancel');},listenerOptions);
        }
        if(backdrop&&!backdrop.dataset.qxBound){
          backdrop.dataset.qxBound='true';
          backdrop.addEventListener('click',function(event){
            if(event.target===backdrop)choose('cancel');
          },listenerOptions);
        }
      }

      function removeLine(line){
        return fetch(activeRoot.dataset.cartChangeUrl,{
          method:'POST',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({id:line.key,quantity:0})
        }).then(function(response){
          if(!response.ok)throw response;
          return response.json();
        });
      }

      function resolveDedup(payload,meta){
        payload=withSections(payload||{});
        meta=meta||{};
        if(!enabled()){
          return Promise.resolve({action:'add',payload:payload});
        }

        return fetchCart().then(function(cart){
          var conflict=findConflict(cart,payload,meta);
          if(!conflict){
            return {action:'add',payload:payload,cart:cart};
          }

          return openModal(conflict,payload,meta).then(function(choice){
            if(choice==='cancel'){
              return {action:'cancel',payload:payload,cart:cart};
            }
            if(choice==='swap'){
              return removeLine(conflict).then(function(updatedCart){
                return {action:'add',payload:payload,cart:updatedCart,swapped:true};
              });
            }
            return {action:'add',payload:payload,cart:cart,keepBoth:true};
          });
        }).catch(function(){
          return {action:'add',payload:payload};
        });
      }

      function dispatchCartUpdate(resource,sourceId,variantId,sections){
        document.dispatchEvent(new CustomEvent('cart:update',{
          bubbles:true,
          detail:{
            resource:resource,
            sourceId:sourceId||'qx-cart-dedup',
            data:{
              source:'qx-cart-dedup',
              itemCount:resource&&resource.item_count?resource.item_count:1,
              variantId:variantId?String(variantId):'',
              sections:sections||{}
            }
          }
        }));
      }

      function openCartDrawer(){
        if(window.QxCartDrawer&&typeof window.QxCartDrawer.open==='function'&&document.body.dataset.template!=='cart'){
          window.QxCartDrawer.open();
          return;
        }
        var drawer=document.querySelector('cart-drawer-component');
        if(drawer&&typeof drawer.open==='function'&&document.body.dataset.template!=='cart'){
          drawer.open();
        }
      }

      function payloadFromFormData(formData){
        return {
          id:Number(formData.get('id')),
          quantity:Number(formData.get('quantity'))||1,
          selling_plan:formData.get('selling_plan')?Number(formData.get('selling_plan')):null
        };
      }

      function setButtonLoading(button,on){
        if(!button)return;
        if(on){
          button.dataset.qxOriginalText=button.textContent;
          button.disabled=true;
          button.textContent='Checking...';
          return;
        }
        button.disabled=false;
        if(button.dataset.qxOriginalText){
          button.textContent=button.dataset.qxOriginalText;
          delete button.dataset.qxOriginalText;
        }
      }

      function formMeta(form){
        var component=form.closest('product-form-component');
        var quickAdd=form.closest('quick-add-component');
        return {
          productId:(component&&component.dataset.productId)||form.dataset.productId||'',
          productTitle:(quickAdd&&quickAdd.dataset.productTitle)||form.dataset.productTitle||document.title.replace(' - Misty Essence',''),
          newLabel:form.querySelector('[name=\"selling_plan\"]')&&form.querySelector('[name=\"selling_plan\"]').value?'subscription':'one-time purchase'
        };
      }

      function handleFormSubmit(event){
        var form=event.target;
        if(!(form instanceof HTMLFormElement))return;
        if(form.matches('[data-qx-hidden-form]'))return;

        var action=form.getAttribute('action')||'';
        if(action.indexOf('/cart/add')===-1)return;
        if(!enabled())return;
        if(form.checkValidity&&form.checkValidity()===false)return;

        event.preventDefault();
        event.stopImmediatePropagation();

        var submitter=event.submitter||form.querySelector('button[type=\"submit\"],button[name=\"add\"],input[type=\"submit\"]');
        var formData=new FormData(form);
        appendSectionsToFormData(formData);
        var payload=payloadFromFormData(formData);
        var meta=formMeta(form);

        if(!payload.id){
          return;
        }

        setButtonLoading(submitter,true);

        resolveDedup(payload,meta).then(function(result){
          if(result.action==='cancel'){
            setButtonLoading(submitter,false);
            return null;
          }

          return fetch(activeRoot.dataset.cartAddUrl,{
            method:'POST',
            headers:{'Accept':'application/json'},
            body:formData
          }).then(function(response){
            if(!response.ok)throw response;
            return response.json();
          }).then(function(response){
            return fetchCart().then(function(cart){
              dispatchCartUpdate(cart,form.getAttribute('id')||'qx-cart-dedup',payload.id,response.sections||{});
              openCartDrawer();
              return cart;
            });
          });
        }).catch(function(){
          if(submitter)submitter.textContent='Try again';
        }).finally(function(){
          window.setTimeout(function(){setButtonLoading(submitter,false);},900);
        });
      }

      document.addEventListener('submit',handleFormSubmit,listenerOptions);
      document.addEventListener('keydown',function(event){
        if(!backdrop||backdrop.hidden)return;
        if(event.key==='Escape'){
          event.preventDefault();
          choose('cancel');
          return;
        }
        if(event.key!=='Tab'||!modal)return;
        var focusable=Array.prototype.slice.call(modal.querySelectorAll('button,[href],input,select,textarea,[tabindex]:not([tabindex=\"-1\"])')).filter(function(item){
          return !item.disabled&&item.offsetParent!==null;
        });
        if(!focusable.length)return;
        var first=focusable[0];
        var last=focusable[focusable.length-1];
        if(event.shiftKey&&document.activeElement===first){
          event.preventDefault();
          last.focus();
        }else if(!event.shiftKey&&document.activeElement===last){
          event.preventDefault();
          first.focus();
        }
      },listenerOptions);

      bindModalButtons();

      window.QxCartDedup={
        __initialized:true,
        setRoot:setRoot,
        resolve:resolveDedup,
        openModal:openModal
      };
    })();
  
  } catch(e) { console.error(e); }
})();
})();
